import React from "react";
import { getpast } from "../function";
import "./styles.css";
export default (props) => {
  return (
    <>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Right</th>
            <th scope="col">Wrong</th>
            <th scope="col">Score</th>
          </tr>
        </thead>
        <tbody>
          {getpast().map((ps, index) => {
            return (
              <tr>
                <td score="row">{1 + index}</td>
                <td>{ps.right}</td>
                <td>{ps.wrong}</td>
                <td>{ps.score}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
// Loading;
